/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import { ref } from "lit/directives/ref.js";
import { nothing, html } from "lit";
import { safeClassMap } from "@arcgis/lumina";
const CSS = {
  validationContainer: "validation-container"
};
const validationReference = () => {
  return;
};
const Validation = ({ scale, status, id, icon, message, ref: ref$1 }) => html`<div class=${safeClassMap(CSS.validationContainer)} ${ref(ref$1 ? ref$1 : validationReference)}><calcite-input-message aria-live=polite .icon=${icon} id=${id ?? nothing} .scale=${scale} .status=${status}>${message}</calcite-input-message></div>`;
export {
  Validation as V
};
